import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, ProcessModule, StateConfig, StateTransferType } from '@spartacus/core';
import { AVAILABILITY_FEATURE } from './store/availability-state';
import { reducerProvider, reducerToken } from './store/reducers';

function availabilityStoreConfigFactory(): StateConfig {
  return {
    state: {
      ssrTransfer: {
        keys: {
          [AVAILABILITY_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
}

@NgModule({
  imports: [
    ProcessModule.forRoot(),
    StoreModule.forFeature(AVAILABILITY_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(availabilityStoreConfigFactory),
  ],
  providers: [reducerProvider],
})
export class AvailabilityDataAccessModule {}
